var currentIndex = 0;

function updateButtons() {
  const slides = document.querySelectorAll(".slide");
  document.getElementById("left-arrow").disabled = currentIndex === 0;
  document.getElementById("right-arrow").disabled =
    currentIndex >= slides.length - 3;
}

function moveSlide(direction) {
  const slides = document.querySelectorAll(".slide");
  const slider = document.getElementById("slider");
  const slideWidth =
    slides[0].offsetWidth +
    parseInt(getComputedStyle(slides[0]).marginRight, 10);

  if (direction === "right" && currentIndex < slides.length - 3) {
    slider.scrollLeft += slideWidth;
    currentIndex++;
  } else if (direction === "left" && currentIndex > 0) {
    slider.scrollLeft -= slideWidth;
    currentIndex--;
  }
  updateButtons();
}

updateButtons();

(function () {
  const slider = document.getElementById("slider");
  if (!slider) return;

  let startX = 0;
  let startScrollLeft = 0;
  let isDragging = false;

  slider.addEventListener("touchstart", function (e) {
    startX = e.touches[0].clientX;
    startScrollLeft = slider.scrollLeft;
    isDragging = true;
  }, { passive: true });

  slider.addEventListener("touchmove", function (e) {
    if (!isDragging) return;
    const delta = startX - e.touches[0].clientX;
    slider.scrollLeft = startScrollLeft + delta;
  }, { passive: true });

  slider.addEventListener("touchend", function () {
    isDragging = false;
    const slides = document.querySelectorAll(".slide");
    if (!slides.length) return;
    const slideWidth =
      slides[0].offsetWidth +
      parseInt(getComputedStyle(slides[0]).marginRight, 10);
    currentIndex = Math.round(slider.scrollLeft / slideWidth);
    currentIndex = Math.max(0, Math.min(currentIndex, slides.length - 1));
    updateButtons();
  });
})();
